export default "__VITE_ASSET__HEpMxfU$__"